import Vue from 'vue';
import VueRouter from 'vue-router';
import StoreDataDashboard from '../views/StoreDataDashboard.vue'
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: StoreDataDashboard
    },
];

const router = new VueRouter({
    routes,
    mode: 'history' // 可选：去除 URL 中的 #（需后端支持）
});


export default router;